import { useState } from 'react'

import { Table } from '@components/shared/Table'

import { parseUnitClassificationGrid } from './helpers/parseUnitClassificationGrid'
import { UnitDreModal } from './UnitDreModal'

import type { UnitDreModalSelectedUnitProps } from './UnitDreModal/types'
import type { UnitClassificationTableProps } from './types'

export const UnitClassificationTable = ({ rows, isLoading, pagination, onSort }: UnitClassificationTableProps) => {
  const [selectedUnit, setSelectedUnit] = useState<UnitDreModalSelectedUnitProps | null>(null)

  const { data } = parseUnitClassificationGrid(rows, setSelectedUnit)

  return (
    <>
      <Table
        data={data}
        isLoading={isLoading}
        onSort={onSort}
        footer={pagination ? { pagination } : undefined}
      />

      <UnitDreModal open={!!selectedUnit} unit={selectedUnit} onClose={() => setSelectedUnit(null)} />
    </>
  )
}
